'use client';

import '@ui5/webcomponents/dist/TimePicker.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `TimePicker` component provides an input field with assigned clocks which are opened on user action. The `TimePicker` allows users to select a localized time using touch, mouse, or keyboard input. It consists of two parts: the time input field and the clocks.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-TimePicker)
 */
const TimePicker = withWebComponent('ui5-time-picker', ['formatPattern', 'placeholder', 'value', 'valueState'], ['disabled', 'readonly'], ['valueStateMessage'], ['change', 'input']);
TimePicker.displayName = 'TimePicker';
TimePicker.defaultProps = {
  valueState: ValueState.None
};
export { TimePicker };